export default "__VITE_ASSET__CybO_nPu__"